export const ADMIN_GROUP = 'ADMIN';

export const DASHBOARD_GROUPS = {
  transactionHpg: 'TRANSACTION_HPG',
  transactionIso: 'TRANSACTION_ISO',
  clientCredential: 'CLIENT_CREDENTIAL',
  terminal: 'TERMINAL'
} as const;

export type DashboardGroup = (typeof DASHBOARD_GROUPS)[keyof typeof DASHBOARD_GROUPS];

export interface NavigationItem {
  label: string;
  path: string;
  icon: string;
  group?: DashboardGroup;
  description?: string;
  color?: 'blue' | 'amber' | 'cyan';
  children?: NavigationItem[];
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    label: 'Movimientos',
    path: '/transactions',
    icon: '↔',
    description: 'Operaciones procesadas, estados, tarjetas y origenes.',
    color: 'blue',
    children: [
      { label: 'Transacciones', path: '/transactions', icon: '↔', group: DASHBOARD_GROUPS.transactionHpg },
      { label: 'Transacciones GP', path: '/transactions-gp', icon: 'G', group: DASHBOARD_GROUPS.transactionHpg },
      { label: 'Transacciones Payway', path: '/transactions-iso', icon: '▣', group: DASHBOARD_GROUPS.transactionIso }
    ]
  },
  {
    label: 'Terminales',
    path: '/terminales',
    icon: '▥',
    group: DASHBOARD_GROUPS.terminal,
    description: 'Gestion de terminales POS y terminales virtuales.',
    color: 'blue',
    children: [
      { label: 'Terminales', path: '/terminales', icon: '▥', group: DASHBOARD_GROUPS.terminal },
      { label: 'Configurar terminal', path: '/configurar-terminal', icon: '⚙', group: DASHBOARD_GROUPS.terminal }
    ]
  },
  {
    label: 'PAYWAY',
    path: '/payway',
    icon: 'P',
    group: DASHBOARD_GROUPS.terminal,
    description: 'Asignacion de terminales para el adquirente Payway.',
    color: 'amber'
  },
  {
    label: 'Global Processing',
    path: '/gp-conciliacion/sftp',
    icon: 'G',
    description: 'Layouts y conciliaciones de Global Processing.',
    color: 'cyan',
    children: [
      {
        label: 'Submerchant', path: '/global-processing/submerchant', icon: '◇',
        group: DASHBOARD_GROUPS.terminal
      },
      {
        label: 'GP Layout', path: '/gp-conciliacion/sftp', icon: '≋',
        group: DASHBOARD_GROUPS.transactionHpg,
        children: [
          { label: 'SFTP', path: '/gp-conciliacion/sftp', icon: '⇧', group: DASHBOARD_GROUPS.transactionHpg },
          { label: 'Presentaciones', path: '/gp-conciliacion/liquidaciones/presentaciones', icon: '▤', group: DASHBOARD_GROUPS.transactionHpg },
          { label: 'Liquidaciones', path: '/gp-conciliacion/liquidaciones/liquidaciones', icon: '$', group: DASHBOARD_GROUPS.transactionHpg },
          { label: 'Totales', path: '/gp-conciliacion/liquidaciones/totales', icon: 'Σ', group: DASHBOARD_GROUPS.transactionHpg },
          { label: 'Contracargo', path: '/gp-conciliacion/liquidaciones/contracargos', icon: '↩', group: DASHBOARD_GROUPS.transactionHpg }
        ]
      },
      {
        label: 'GP Conciliaciones', path: '/gp-conciliaciones', icon: '✓',
        group: DASHBOARD_GROUPS.transactionHpg
      }
    ]
  },
  {
    label: 'QR Interoperable',
    path: '/qr-interoperable',
    icon: '▦',
    group: DASHBOARD_GROUPS.terminal,
    description: 'Asignación de cajas y QR a terminales virtuales.',
    color: 'cyan',
    children: [
      { label: 'BIND', path: '/qr-interoperable/bind', icon: 'B', group: DASHBOARD_GROUPS.terminal }
    ]
  },
  {
    label: 'Client credentials',
    path: '/client-credentials',
    icon: '◆',
    group: DASHBOARD_GROUPS.clientCredential,
    description: 'Alta, consulta y baja de clientes M2M en Cognito.',
    color: 'cyan'
  }
];
